import React from 'react'

type UploadProps = { width?: string; height?: string; color?: string }

function Upload({
  width = '42',
  height = '42',
  color = '#E8E8E8',
}: UploadProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 42 42'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.5833 18.9167C8.64589 18.9167 7.67717 18.9167 6.88238 19.1296C4.72556 19.7075 3.04088 21.3922 2.46296 23.549C2.25 24.3438 2.25 25.3126 2.25 27.25V29.75C2.25 33.2503 2.25 35.0005 2.93121 36.3374C3.53042 37.5135 4.48655 38.4696 5.66256 39.0688C6.99951 39.75 8.74967 39.75 12.25 39.75H29.75C33.2503 39.75 35.0005 39.75 36.3374 39.0688C37.5135 38.4696 38.4696 37.5135 39.0688 36.3374C39.75 35.0005 39.75 33.2503 39.75 29.75V27.25C39.75 25.3126 39.75 24.3438 39.537 23.549C38.9591 21.3922 37.2744 19.7075 35.1176 19.1296C34.3228 18.9167 33.3541 18.9167 31.4167 18.9167M29.3333 10.5833L21 2.25M21 2.25L12.6667 10.5833M21 2.25V27.25'
        strokeWidth='3'
        strokeLinejoin='round'
        strokeLinecap='round'
        stroke={color}
      />
    </svg>
  )
}

export default Upload
